import { Members } from "~/api/apiRouteTypes/MembersRoute";
import { fetchData } from "~/utils/fetch";

export type MemberResult =
  Members.GetMembersMemberidControllerHandle.ResponseBody;
export type DaoMemberResultData = MemberResult["data"] | null;
export type DaoMemberItem = NonNullable<MemberResult["data"]>;

type Props = Members.GetMembersMemberidControllerHandle.RequestParams;

export const getMember = ({ memberId }: Props) =>
  fetchData<MemberResult>({
    url: `/members/${memberId}`,
  });
